import React from "react";
import {
  Box,
  Container,
  Text,
  VStack,
  HStack,
  Link,
  Icon,
  Divider,
  SimpleGrid,
} from "@chakra-ui/react";
import { FaHeart, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  return (
    <Box
      as="footer"
      bg="gray.900"
      color="white"
      py="12"
      borderTop="1px"
      borderColor="gray.700"
    >
      <Container maxW="container.xl">
        <VStack spacing={8}>
          {/* Main Footer Content */}
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} w="100%">
            {/* Brand Section */}
            <VStack align={{ base: "center", md: "start" }} spacing={4}>
              <Text fontSize="xl" fontWeight="bold" color="teal.400">
                Vartaverse
              </Text>
              <Text
                fontSize="sm"
                color="gray.400"
                textAlign={{ base: "center", md: "left" }}
              >
                Create amazing spaces for every purpose. Connect, communicate,
                and collaborate seamlessly.
              </Text>
            </VStack>

            {/* Connect Section - Email Only */}
            <VStack align={{ base: "center", md: "start" }} spacing={4}>
              <Text fontWeight="semibold" color="white" mb={2}>
                Connect
              </Text>
              <Link
                href="mailto:admin@vartverse.com"
                _hover={{ color: "teal.400" }}
                display="flex"
                alignItems="center"
                gap={2}
              >
                <Icon as={FaEnvelope} boxSize={4} />
                <Text fontSize="sm">admin@vartverse.com</Text>
              </Link>
            </VStack>
          </SimpleGrid>

          <Divider borderColor="gray.700" />

          {/* Bottom Section */}
          <HStack
            justify={{ base: "center", md: "space-between" }}
            align="center"
            w="100%"
            flexDirection={{ base: "column", md: "row" }}
            spacing={{ base: 4, md: 0 }}
          >
            <Text fontSize="sm" color="gray.400" textAlign="center">
              &copy; {new Date().getFullYear()} Vartaverse. All rights reserved.
            </Text>
            <HStack spacing={1} fontSize="sm" color="gray.400">
              <Text>Made with</Text>
              <Icon as={FaHeart} color="red.400" />
              <Text>for better communication</Text>
            </HStack>
          </HStack>
        </VStack>
      </Container>
    </Box>
  );
};

export default Footer;
